import {iosBookHttp, womensAdminHttp, womenUserHttp} from './index'
import ElementUI, {Message} from "element-ui";

function iosRequest(url, method, data) {
    return womensAdminHttp({
        url: url,
        method: method,
        data: data
    })
}

function iosWmUserRequest(url, method, data) {
    return womenUserHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return iosRequest(url, 'get', data)
}
function getWmUser(url, data) {
    return iosWmUserRequest(url, 'get', data)
}


function post(url, data) {
    return iosRequest(url, 'post', data)
}

export function ruleConfigList() {
    return get('/config/list')
}

export function deleteRuleConfig(id) {
    return get('/config/delete/' + id)
}

export function deleteVersion(id) {
    return get('/config/deleteVersion/' + id)
}

export function saveRuleConfig(data) {
    return post('/config/save', data)
}

export function searchRuleConfig(data) {
    return post('/config/search',data)
}


// 运营位相关
export function allOperationPosition(){
    return get('/operationPosition/list')
}

export function editOperationPosition(data) {
    return post('/operationPosition/saveAndUpdate', data)
}

export function allOperationPositionActivity(data) {
    return post('/operationPosition/activityList', data)
}


export function cleanF(ids, nickIds) {
    return getWmUser('/user/clearIds/' + ids + "/" + nickIds)
}

export function allSelect() {
    return get('/operationPosition/comboBoxList')
}

export function editOPActivity(data) {
    return post('/operationPosition/saveAndUpdateActivity', data)
}

export function deleteOPActivity(opaId) {
    return get('/operationPosition/deleteActivity/' + opaId)
}
export function versionList() {
    return get('/config/listVersion')
}

export function saveVersion(data) {
    return post('/config/saveVersion', data)
}

export function upload(data) {
    return post('/block/upload', data)
}

export function appLinks() {
    return get('/block/appLinks')
}

export function saveAppLink(data) {
    return post('/block/saveAppLink', data)
}

export function deleteAppLink(id) {
    return get('/block/deleteAppLink/' + id)
}

export function blocks() {
    return get('/block/blocks')
}

export function saveBlock(data) {
    return post('/block/saveBlock', data)
}

export function blockAppLinks(id) {
    return get('/block/findBlockAppLinks/' + id)
}

export function saveBlockAppLink(data) {
    return post('/block/saveBlockAppLink', data)
}

export function updateBlockAppLink(data) {
    return post('/block/updateBlockAppLink', data)
}

export function icons() {
    return get('/icon/icons')
}

export function saveIcon(data) {
    return post('/icon/saveIcon', data)
}

export function deleteIcon(id) {
    return get('/icon/deleteIcon/' + id)
}

export function searchIcon(data) {
    return post('/icon/searchIcon', data)
}

export function searchIconCategory(data) {
    return post('/icon/searchIconCategory', data)
}

export function searchAppLink(data) {
    return post('/block/searchAppLink', data)
}

export function searchBlock(data) {
    return post('/block/searchBlock', data)
}

export function findAppLinkIconRel(id) {
    return get('/block/findAppLinkIconRel/' +id)
}

export function selections() {
    return get('/block/selections')
}

export function deleteBlock(id) {
    return get('/block/deleteBlock/' + id)
}

export function deleteBlockAppLink(id) {
    return get('/block/deleteBlockAppLink/' + id)
}
export function saveIconCategory(data) {
    return post('/icon/saveIconCategory', data)
}

export function deleteIconCategory(id) {
    return get('/icon/deleteIconCategory/' + id)
}

export function findIconCategoryRel(id) {
    return get('/icon/findIconCategoryRel/' + id)
}

export function saveIconCategoryRel(data) {
    return post('/icon/saveIconCategoryRel', data)
}

export function saveAppLinkIconRel(data) {
    return post('/block/saveAppLinkIconRel', data)
}

export function saveLiveActivity(data) {
    return post('/live/saveLiveActivity', data)
}

export function deleteLiveActivity(id) {
    return get('/live/deleteLiveActivity/' + id)
}

export function searchLiveActivity(data) {
    return post('/live/searchLiveActivity', data)
}

export function deleteLiveActivityImage(id) {
    return get('/live/deleteLiveActivityImageRel/' + id)
}

export function saveLiveActivityImage(data) {
    return post('/live/saveLiveActivityImageRel', data)
}

export function updateLiveActivityImage(data) {
    return post('/live/updateLiveActivityImageRel', data)
}

export function searchLiveActivityImage(liveActivityId) {
    return get('/live/findLiveActivityImageRelByLiveActivityId/' + liveActivityId)
}

//新版本配置
// export function ruleConfigList() {
//     return get('/config/list')
// }

export function deleteTotalRuleConfig(id) {
    return get('/config/total/delete/' + id)
}

export function deleteTotalVersion(version,appType) {
    return get('/config/total/deleteVersion?appType=' + appType+'&version='+version)
}

export function saveTotalRuleConfig(data) {
    return post('/config/total/save', data)
}

export function searchTotalRuleConfig(data) {
    return post('/config/total/search',data)
}

export function totalVersionList(data) {
    return get('/config/total/listVersion?appType='+data)
}

export function saveTotalVersion(data) {
    return post('/config/total/saveVersion', data)
}

// ios 版本更新相关接口
export function deleteVersionConfig(id) {
    return get('/version/delete?id='+id)
}

export function searchVersionConfig(data) {
    return post('/version/search', data)
}
export function updateVersionConfig(data) {
    return post('/version/update', data)
}
// ios 版本更新文案相关接口
export function deleteVersionMessage(id) {
    return get('/version/message/delete?id='+id)
}

export function searchVersionMessage(data) {
    return post('/version/message/search', data)
}
export function updateVersionMessage(data) {
    return post('/version/message/update', data)
}
// ios 物品相关接口
export function deleteGood(id) {
    return get('/good/delete?id='+id)
}

export function searchGood(data) {
    return post('/good/search', data)
}
export function updateGood(data) {
    return post('/good/update', data)
}

export function goodsList() {
    return get('/good/list')
}


export function dogCategoryList() {
    return get('/good/categoryList')
}

export function dogCategoryAll() {
    return get('/good/categoryAll')
}

export function womenTaskSelections() {
    return get('/order/selections')
}

export function searchTask(data) {
    return post('/task/searchTask', data)
}

export function saveTask(data) {
    return post('/task/saveTask', data)
}

export function updateTaskState(taskId,state) {
    return get('/task/updateTaskState/'+taskId+"/"+state)
}

export function rechargeSelections() {
    return get('/recharge/selections')
}

export function searchRecharge(data) {
    return post('/recharge/search', data)
}

export function saveRecharge(data) {
    return post('/recharge/save', data)
}

export function updateRechargeState(id,state) {
    return get('/recharge/updateState/'+id+"/"+state)
}

export function updateReEnableFirstRechargeState(id) {
    return get('/recharge/updateReEnableFirstRechargeState/'+id)
}

export function searchRechargeGroup() {
    return get('/recharge/searchGroup')
}

export function saveRechargeGroup(data) {
    return post('/recharge/saveGroup', data)
}

export function updateRechargeGroupState(id,state) {
    return get('/recharge/updateGroupState/'+id+"/"+state)
}


export function goodsSelections() {
    return get('/good/list')
}

export function goodsLevel() {
    return get('/good/level')
}

export function findGoodById(id) {
    return get('/good/findGoodById/'+id)
}

export function shopSelections() {
    return get('/shop/selectionList')
}

// 获取商城子标签信息
export function subClassifySelections(parentId) {
    return get('/shop/subSelectionList?parentId='+parentId)
}

export function searchShop(data) {
    return post('/shop/search', data)
}

export function deleteShopItem(itemId) {
    return get('/shop/delete/'+itemId)
}

export function saveShopItem(classifyId,data) {
    return post('/shop/save/'+classifyId, data)
}

export function classifyUpdate(data) {
    return post('/shop/classify/update', data)
}

export function shelvesListByClassifyId(id) {
    return get('/shop/itemList/'+id)
}

export function shopItemAll(id) {
    return get('/shop/itemListAll/'+id)
}

export function updateShelvesRank(data) {
    return post('/shop/itemList/updateRank', data)
}

export function shopItemClassifyList() {
    return get('/shop/shopItemClassifyList')
}
// 商城每日优惠相关接口
export function dailyShopItemType() {
    return get('/shop/daily/type')
}

export function searchDailyShopItem(data) {
    return post('/shop/daily/search',data)
}

export function saveDailyShopItem(data) {
    return post('/shop/daily/save', data)
}

export function deleteDailyShopItem(id) {
    return get('/shop/daily/delete?id='+id)
}

export function saveABTest(data) {
    return post('/ab/test/save', data)
}

export function searchABTest(data) {
    return post('/ab/test/search', data)
}

export function removeABTest(data) {
    return post('/ab/test/remove', data)
}

export function orderSearch(data) {
    return post('/order/search', data)
}

export function saveFlag(data) {
    return post('/dogFlag/save', data)
}

export function searchFlag(data) {
    return post('/dogFlag/search', data)
}

export function removeFlag(data) {
    return post('/dogFlag/remove', data)
}

export function sysVip(data) {
    return post('/order/sys/vip', data)
}

export function allDiscovers() {
    return get('/discover/list')
}

export function allDiscoverDetails(data) {
    return post('/discover/detailList',data)
}

export function allDiscoverDetailsJqAdd(data) {
    return post('/discover/detailList/jq/save',data)
}
export function allDiscoverDetailsJqDel(data) {
    return post('/discover/detailList/jq/del',data)
}

export function allDiscoverDetailsRmAdd(data) {
    return post('/discover/detailList/rm/save',data)
}
export function allDiscoverDetailsRmDel(data) {
    return post('/discover/detailList/rm/del',data)
}

export function discoverSelector(id, data) {
    return post('/discover/selector/' + id, data)
}

export function discoverSelected(_id) {
    return get('/discover/selected/' + _id)
}

export function allDiscoversEnums() {
    return get('/discover/enums')
}

export function saveDiscover(data) {
    return post('/discover/saveDiscover',data)
}

export function deleteDiscover(data) {
    return post('/discover/deleteDiscover/'+data)
}

export function saveDiscoverDetail(data) {
    return post('/discover/saveDiscoverDetail',data)
}

export function deleteDiscoverDetail(data) {
    return post('/discover/deleteDiscoverDetail/'+data)
}

// 标签树形结构
export function getTagTree() {
    return get('/api/tags/tree')
}

// 未隐藏标签树形结构
export function getTagTreeWithoutHide() {
    return get('/api/tags/tree/unhidden')
}

// 标签列表
export function getTagList() {
    return get('/api/tags/list')
}

// 根据ID查标签
export function getTagById(id) {
    return get(`/api/tags/${id}`)
}

// 未隐藏标签单查
export function getUnhiddenTagById(id) {
    return get(`/api/tags/unhidden/${id}`)
}

// 保存标签（新增/编辑）
export function saveTag(data) {
    return post('/api/tags/save', data)
}

// 删除标签
export function deleteTag(id) {
    return get(`/api/tags/delete/${id}`)
}


function requestBuffer(url, method, data) {
    return womensAdminHttp({
        url: url,
        method: method,
        data: data,
        responseType: 'arraybuffer'
    })
}

export function downloadDataDog(url, data, fileName) {
    return requestBuffer(url, 'post', data).then(data => {
        try {
            let enc = new TextDecoder('utf-8')
            let body = JSON.parse(enc.decode(new Uint8Array(data.data)))
            if (body.status !== 0) {
                Message({
                    type: "error",
                    message: body.msg
                });
            }
        } catch (error) {
            console.log(error)
            let blobObject = new Blob([data.data]);
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                let link = document.createElement("a");
                link.href = URL.createObjectURL(blobObject);
                link.download = fileName;
                link.click();
            }
            ElementUI.Message({
                message: '导出Excel成功！',
                type: "success",
            })
        }
    })
}


